module.exports = __webpack_public_path__ + "img/bobgreenlogo.bb21b5b5.png";